<ckeditor
    [editor]="Editor"
    [config]="config"
    (ready)="onReady($event)"
    (change)="onChange($event)"
    [(ngModel)]="model"
></ckeditor>